import React from 'react'
import CtaCard from '../layout/CtaCard'

type Props = { question: string; onClick: (question: string) => void }

const QuestionCard: React.FC<Props> = ({ question, onClick }) => (
  <CtaCard onClick={() => onClick(question)}>{question}</CtaCard>
)

export default QuestionCard
